import { useState } from 'react';
import { toast } from 'react-toastify';
import { AlbumsTable } from '../albums/albums-table';
import { useCreateAlbumMutation } from '../albums/albums.api';
import { Pager } from '../pager/pager';
import { useGetEventAlbumsQuery } from './events.api';
import { IEvent } from '@topshots/core-models';
// import { Event } from './events.types';

export const EventAlbums = ({ event }: { event: IEvent }) => {
  //const navigate = useNavigate();
  const [create] = useCreateAlbumMutation();
  const [page, setPage] = useState<number>(1);
  const [perPage, setPerPage] = useState<number>(10);
  //const [newAlbumName, setNewAlbumName] = useState<string>('');
  const { data, isLoading, isFetching } = useGetEventAlbumsQuery({
    page,
    perPage,
    eventId: event._id.toString(),
  });
  if (isLoading || isFetching) return <span>loading...</span>;

  return (
    <>
      <AlbumsTable
        albums={data?.data ?? []}
        onCreate={async (name) => {
          await create({
            event_id: event,
            name: name,
          });
          toast.success('Album created');
        }}
      />
      <Pager
        onNext={() => {
          setPage(page + 1);
        }}
        onPrevious={() => {
          setPage(page - 1);
        }}
        onPageSelected={(selected) => {
          setPage(selected);
        }}
        onPerPageChange={(selected) => {
          setPerPage(selected);
          setPage(1);
        }}
        page={page}
        perPage={perPage}
        totalPages={data?.totalPages ?? 1}
      />
    </>
  );
};
